import {useAuth0} from "@auth0/auth0-react";
import {CreatorApplication} from "../model/creator_application";

export function useCreatorApplicationAPI() {
    const {getAccessTokenSilently} = useAuth0();

    const findApplications = (params: {
        q: string;
        limit: number;
        offset: number;
        status?: string
    }): Promise<CreatorApplication[]> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                const query = new URLSearchParams({
                    q: params.q,
                    limit: params.limit.toString(),
                    offset: params.offset.toString(),
                });
                if (params.status) {
                    query.append("status", params.status);
                }
                fetch(`${process.env.REACT_APP_API_URL}/creator-application/admin/find?${query.toString()}`, {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            response.json().then((data: CreatorApplication[]) => resolve(data)).catch(reject);
                        } else {
                            reject(new Error("Failed to fetch creator applications: " + response.statusText));
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const getApplication = (id: string): Promise<CreatorApplication> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/creator-application/admin/${id}`, {
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            response.json().then((data: CreatorApplication) => resolve(data)).catch(reject);
                        } else {
                            reject(new Error("Failed to fetch creator application: " + response.statusText));
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const updateApplicationStatus = (id: string, status: string): Promise<CreatorApplication> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                const queryParams = new URLSearchParams();
                queryParams.append("status", status);
                fetch(`${process.env.REACT_APP_API_URL}/creator-application/admin/${id}/status?${queryParams.toString()}`, {
                    method: "PUT",
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.ok) {
                            response.json().then((data: CreatorApplication) => resolve(data)).catch(reject);
                        } else {
                            response.json().then((error) => {
                                if (error.message) {
                                    reject(new Error(error.message));
                                } else {
                                    reject(new Error(JSON.stringify(error)));
                                }
                            });
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    const deleteApplication = (id: string): Promise<void> => {
        return new Promise((resolve, reject) => {
            getAccessTokenSilently().then((accessToken) => {
                fetch(`${process.env.REACT_APP_API_URL}/creator-application/admin/${id}`, {
                    method: "DELETE",
                    headers: {
                        authorization: `Bearer ${accessToken}`,
                    },
                })
                    .then((response) => {
                        if (response.ok) {
                            resolve();
                        } else {
                            response.json().then((error) => {
                                if (error.message) {
                                    reject(new Error(error.message));
                                } else {
                                    reject(new Error(JSON.stringify(error)));
                                }
                            });
                        }
                    })
                    .catch(reject);
            }).catch(reject);
        });
    };

    return {
        findApplications,
        getApplication,
        updateApplicationStatus,
        deleteApplication,
    };
}

